/* biome-ignore-all lint/suspicious/noExplicitAny: reading content api */
import { HttpRequest } from "@/utils/request"
import type { ReadingSetItem, ReadingContentItem } from "@/views/notebook/reading-content/types"

export interface ReadingContentSearchParams {
  page: number
  limit: number
  search?: string
  type?: string
  difficulty?: string
  status?: string
  set_id?: number
}

export const readingContentService = {
  list(params: ReadingContentSearchParams) {
    return HttpRequest.get("v1/reading-contents", {
      searchParams: params as any,
    }).json<{
      code: number
      data: ReadingSetItem[]
      total: number
      page: number
      limit: number
    }>()
  },

  getDetail(id: number | string) {
    return HttpRequest.get(`v1/reading-contents/${id}`).json<{
      code: number
      data: ReadingContentItem
    }>()
  },
}
